import React from 'react'
import styled from 'styled-components'
import { useRevealProps } from '../../MwPage/components/Reveal'
import { ink, sans, Section, ui } from '../../MwPage/styled'
import { TrialButton } from '../components/TrialCta'
import { useFocus } from '../focus'
import { Wrap } from '../styled'

// the prototype's .journey: a blue-to-cyan panel with a pale disc in its corner
const Panel = styled.div`
  position: relative;
  overflow: hidden;
  padding: 28px 24px;
  border-radius: 26px;
  color: #ffffff;
  background: linear-gradient(135deg, #2f6fe0 0%, #2f93bf 55%, #17c3d4 100%);
  box-shadow: 0 18px 40px rgba(47, 111, 224, 0.25);

  &::after {
    content: '';
    position: absolute;
    right: -70px;
    top: -70px;
    width: 240px;
    height: 240px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.12);
  }

  > * {
    position: relative;
    z-index: 1;
  }

  h2 {
    margin: 0 0 10px;
    max-width: 780px;
    font: 800 clamp(24px, 4.4vw, 34px) / 1.1 ${sans};
    letter-spacing: -0.03em;
    color: #ffffff;
  }

  p {
    margin: 0 0 14px;
    max-width: 720px;
    font-size: 16px;
    line-height: 1.6;
    color: rgba(255, 255, 255, 0.93);
  }
`

const Kicker = styled.span`
  display: inline-block;
  margin-bottom: 12px;
  padding: 6px 12px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.18);
  font: 800 11.5px/1.3 ${ui};
  letter-spacing: 0.14em;
  text-transform: uppercase;
`

const Must = styled.p`
  && {
    margin: 0 0 12px;
    font: 800 clamp(17px, 2.8vw, 21px) / 1.3 ${sans};
    letter-spacing: -0.01em;
    color: #fff2b3;
  }
`

const Items = styled.ul`
  list-style: none;
  margin: 14px 0 22px;
  padding: 0;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(220px, 100%), 1fr));
  gap: 8px;

  li {
    position: relative;
    padding: 11px 12px 11px 42px;
    border-radius: 14px;
    border: 1px solid rgba(255, 255, 255, 0.28);
    background: rgba(255, 255, 255, 0.14);
    font: 700 15px/1.35 ${sans};
  }

  li::before {
    content: '✓';
    position: absolute;
    left: 13px;
    top: 12px;
    display: grid;
    place-items: center;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: #ffffff;
    color: #2f6fe0;
    font: 800 11.5px/1 ${sans};
  }
`

// the prototype's .btn.light: the page's button in white on the panel
const LightButton = styled(TrialButton)`
  && {
    background: #ffffff;
    color: ${ink};
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
  }

  svg {
    color: #0f7b8a;
  }
`

const Fine = styled.p`
  && {
    margin: 12px 0 0;
    font-size: 12px;
    line-height: 1.55;
    color: rgba(255, 255, 255, 0.88);
  }
`

/** "Your 30-day journey": the invitation on a gradient panel, with its own button label. */
const InviteSection = ({ offer }) => {
  const { invite } = useFocus()

  return (
    <Section style={{ padding: '34px 24px 8px' }}>
      <Wrap>
        <Panel {...useRevealProps()}>
          <Kicker>{invite.kicker}</Kicker>
          <h2>{invite.headline}</h2>
          <Must>{invite.must}</Must>
          <p>{invite.text}</p>
          <Items>
            {invite.items.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </Items>
          <LightButton offer={offer}>{invite.cta}</LightButton>
          <Fine>{invite.fine}</Fine>
        </Panel>
      </Wrap>
    </Section>
  )
}

export default InviteSection
